module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/wedding-desktop@2x-6a3f2d9be5d3389f0b4f82a66d796f1f.jpg";